import { Icon } from 'antd';
import * as React from 'react';
const sendSvg = (props: any) => (
  <svg {...props} width="18px" height="18px"  version="1.1"
  xmlns="http://www.w3.org/2000/svg">
    <desc>Created with Sketch.</desc>
    <g id="Send" stroke="none" strokeWidth="1"
    fill="none" fillRule="evenodd">
        <polygon id="Bounds-Copy-4" points="0 0 21 0 21 21 0 21"></polygon>
        <polygon id="Shape-Copy-4" {...props.style}
        points="2.00803571 18 18.875 10.5 2.00803571 3 2 8.83333333
        14.0535714 10.5 2 12.1666667"></polygon>
    </g>
</svg>
);
const sendIcon = props => (
  <Icon component={(innerProps) => {
    return sendSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);

export default sendIcon;
